import labsCommonStrings from 'modules/labs/common/strings';

import { contexts } from 'constants/contexts';

export const operationsAppEnums = {
  vlabs: '1',
  vpharmacy: '2',
};

export const sidebarItems = [
  {
    context: 'orders',
    name: labsCommonStrings.sidebar.ordersItemName,
    icon: '"\\e901"',
  },
  {
    context: contexts.vendors,
    name: labsCommonStrings.sidebar.labsItemName,
    icon: '"\\e903"',
  },
  {
    context: contexts.masterList,
    name: labsCommonStrings.sidebar.masterListItemName,
    icon: '"\\e900"',
  },
];
